import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthStore } from "../../../store/useAuthStore";
import "../modal.css";
import { Lock, Unlock } from "lucide-react";

const ConfirmPasswordPopup = ({ onClose,userId }) => {

  const {confirmPassword} = useAuthStore()

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const handleConfirmPassword = async (values) => {
    const result = await confirmPassword({
      user_id: userId,
      ...values
    })

    if(result?.status) {
      toast.success("Password reset successfully, you can now login", {toastId: 'successMessageConfirmPassword'});
      onClose()
    } else {
      toast.error(result?.message ?? 'somwthing went wrong', {toastId: 'errorMessageConfirmPassword'})
    }
  }

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords do not match")
        .required("Confirm Password is required"),
    }),
    onSubmit: (values) => {
      handleConfirmPassword(values)
    },
  });

  return ReactDOM.createPortal(
    <>
      <div className="custom-modal-backdrop" onClick={onClose}></div>
      <div className="custom-modal">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">Reset Password</h5>
            <button className="custom-close-btn" onClick={onClose}>&times;</button>
          </div>
          <div className="custom-modal-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="form-group">
                <label>Enter Password</label>
                <div className="input-group" style={{position: 'relative'}}>
                  <input
                    type={passwordVisible ? "text" : "password"}
                    className={`custom-input ${formik.touched.password && formik.errors.password ? "error" : ""}`}
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {
                    passwordVisible ? <Lock onClick={() => setPasswordVisible(false)} className="toggle-visibility"/> : <Unlock onClick={() => setPasswordVisible(true)} className="toggle-visibility" /> 
                  }
                </div>
                {formik.touched.password && formik.errors.password && <div className="error-text">{formik.errors.password}</div>}
              </div>

              <div className="form-group">
                <label>Confirm Password</label>
                <div className="input-group" style={{position: 'relative'}}>
                  <input
                    type={confirmPasswordVisible ? "text" : "password"}
                    className={`custom-input ${formik.touched.confirmPassword && formik.errors.confirmPassword ? "error" : ""}`}
                    name="confirmPassword"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {
                    confirmPasswordVisible ? <Lock onClick={() => setConfirmPasswordVisible(false)} className="toggle-visibility" /> : <Unlock onClick={() => setConfirmPasswordVisible(true)} className="toggle-visibility" />
                  }
                </div>
                {formik.touched.confirmPassword && formik.errors.confirmPassword && <div className="error-text">{formik.errors.confirmPassword}</div>}
              </div>

              <div className="custom-modal-footer">
                <button type="submit" className="inline-flex w-full justify-center rounded-md bg-emerald-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-emerald-500 sm:ml-3 sm:w-auto">Submit</button>
                <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={onClose}>Close</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("popup-root")
  );
};

export default ConfirmPasswordPopup;
